var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.menu)?_c('Menu'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body",class:(_vm.menu ? 'menu' : ''),style:((_vm.menu ? (_vm.pageShow ? 'left:300px; padding:0; width:calc(100% - 300px)' : 'left:0; padding:0 150px 0; width:100%') : '')),on:{"scroll":function($event){return _vm.handleScroll($event)}}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17fb9af4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 